export const APP_VERSION = 'v261006.150732';
